/**
 * The Bridge Model · Deployments Registry
 *
 * Each entry represents a city/community where the Bridge Model is being
 * proposed or deployed. Adding a future deployment is a 30-second data entry
 * here — no UI refactor required.
 *
 * The site shell, branding, methodology, budget framework, Implementation
 * Strategy, and Developer Group structure all stay the same. Only the
 * deployment-specific data (city stats, partner network, demographic numbers)
 * varies between deployments.
 */

export const parentBrand = {
  name: "The Bridge Model",
  tagline: "A municipal service-connector methodology · proven, replicable, fidelity-audited",
  proprietor: "George Broughton III",
  consultancy: "Sterile Mate LLC",
  domain: "thebridgemodel.org",
  contactEmail: "george.broughton@sterilemate.com",
  samRegistered: true,
  samRegistrationScope: "All Awards · Grants & Contracts",
  cageCode: "9GH66",
  description:
    "Designed and licensed by Sterile Mate LLC. The Bridge Model is a Tri-Portfolio Hub-and-Spoke service-connector framework that municipalities license, deploy, and operate under our fidelity-to-model standards.",
};

export const deployments = [
  {
    id: "baytown",
    slug: "baytown",
    deploymentNumber: 1,
    city: "Baytown",
    county: "Harris County",
    state: "Texas",
    status: "Proposal · Pending CDBG Council Action",
    statusShort: "Proposal",
    statusColor: "#8B0000",
    fundingSource: "CDBG · Harris County Match · MDD",
    targetHouseholds: 1500,
    targetSeniors: 500,
    targetFamilies: 1000,
    launchTarget: "Q3 2026",
    leadAgency: "City of Baytown",
    proposalYear: 2026,
    isPilot: true,
    isProposal: true,
    isActive: false,
    summary:
      "The flagship deployment-in-proposal. Pitches the full Tri-Portfolio model across one Public Housing Portfolio, one Section 8 Voucher Portfolio, and one General Community Portfolio.",
  },
  {
    id: "north-houston",
    slug: "north-houston",
    deploymentNumber: 2,
    city: "North Houston District",
    county: "Harris County",
    state: "Texas",
    status: "Proposal · In Preparation",
    statusShort: "Proposal",
    statusColor: "#8B0000",
    fundingSource: "CDBG · TIRZ · Harris County · Federal Coordination",
    targetHouseholds: 1500,
    targetSeniors: 500,
    targetFamilies: 1000,
    launchTarget: "Q4 2026",
    leadAgency: "North Houston District (Management District)",
    proposalYear: 2026,
    isPilot: false,
    isProposal: true,
    isActive: false,
    sectorMix: ["Aviation & ground services (IAH)", "Allied health (Harris Health network)", "Logistics & distribution", "Hospitality & customer service", "Professional services", "Light manufacturing"],
    summary:
      "Proposal 02 — the diversified workforce hub. Bridge stabilizes families and routes residents into the IAH corridor's multi-sector employer base while anti-displacement protections keep long-time residents rooted as the district transitions from Greenspoint to a vibrant logistics + aviation + allied-health corridor.",
  },
];

export const activeDeployment = deployments[0]; // Baytown · current proposal (no launches yet)

// Roadmap shown publicly so visiting cities see the velocity of the model
export const expansionRoadmap = [
  { period: "2026 · Q1–Q3", city: "Baytown, TX", phase: "Proposal · Pending Council", status: "proposal" },
  { period: "2026 · Q3", city: "North Houston District, TX", phase: "Proposal · In Preparation", status: "proposal" },
  { period: "2026 · Q4", city: "La Porte, TX", phase: "Discovery", status: "next" },
  { period: "2027 · Q1", city: "Pasadena, TX", phase: "Discovery", status: "planned" },
  { period: "2027+", city: "Gulf Coast LMI corridor", phase: "Open to applications", status: "vision" },
];
